import React from 'react';
import { Grid } from '@material-ui/core';
import ArticlePreviewCard from '../containers/client/ArticlePreviewCard';
import { ArticleSummary } from '../../shared/types';
import { getArticleLink } from '../../utils/link.utils';
import { getPublishedData } from './PublishedBy';
import FetchMorePaginator from './FetchMorePaginator';
import { getLinkPrefix } from '../../utils/list-utils';

interface ArticlePreviewListUIProps {
	source: string;
	showPagination?: boolean;
	articles: ArticleSummary[];
	hasNextPage: boolean;
	total?: number;
	fetchMore: () => void;
	displayShowMoreButton: boolean;
	displayArticleCount?: boolean;
}

const ArticlePreviewListUI = ({
	articles,
	hasNextPage,
	source,
	showPagination = true,
	total,
	fetchMore,
	displayShowMoreButton,
	displayArticleCount = true
}: ArticlePreviewListUIProps) => {
	return (
		<Grid container spacing={2}>
			{articles.map((article: ArticleSummary) => <Grid
				key={article._id}
				item
				xs={12}
				sm={6}
				md={4}>
				<ArticlePreviewCard
					source={source}
					title={article?.title}
					channel={article?.premiumChannelDetails}
					publishedData={getPublishedData(article, getLinkPrefix(), true, false)}
					articleLink={getArticleLink(article._id)}
				/>
			</Grid>)}
			{
				showPagination && (
					<Grid
						item
						container
						xs={12}
						justifyContent="space-around"
					>
						<FetchMorePaginator
							hasNextPage={hasNextPage}
							label="articles"
							showingCurrent={articles?.length}
							totalCount={total || 0}
							fetchMore={fetchMore}
							displayShowMoreButton={displayShowMoreButton}
							displayCount={displayArticleCount}
						/>
					</Grid>
				)
			}
		</Grid>
	);
};

export default ArticlePreviewListUI;
